<mat-form-field class="form-control" [appearance]="appearance" style="width: 100%">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [placeholder]="label ? label : 'Email'"
    [type]="hide ? 'password' : 'text'"
    [formControl]="controlName"
  />
  <button
    *ngIf="!hasError() && !isValid()"
    mat-icon-button
    matSuffix
    (click)="hide = !hide"
    [attr.aria-label]="'Hide password'"
    [attr.aria-pressed]="hide"
  >
    <mat-icon color="primary">{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>
  <mat-icon *ngIf="isValid()" matSuffix class="icon-success" (click)="hide = !hide">check_circle</mat-icon>
  <mat-icon *ngIf="hasError()" matSuffix color="warn" (click)="hide = !hide">info</mat-icon>
  <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
</mat-form-field>
